import countries from "../assets/countries"

const getMetaKey = (arr, attr, chartType) => Object.keys(arr).find(key =>
    arr[key].meta?.[chartType]?.type == attr
)

// unused
// const getMetaKeys = (arr, attrName, chartType) => Object.keys(arr).filter(key =>
//     arr[key].meta?.[chartType]?.type == attrName
// )

/**
 * object that helps process cube data based on chart type
 * @type {{bar: (function({queryProps: *, isSentiment?: *, clientName: *}): {data: *, seriesNames: *}), line: (function({queryProps: *}): {data: *, seriesNames: *}), pie: (function({queryProps: *, isSentiment: *, clientName: *}): {data: *, seriesNames: *}), map: (function({queryProps: *}): {data: *}), table: (function({queryProps: *}): {data: *, columns: *})}}
 */
const processForChart = {
    line: ({ queryProps }) => {
        const { resultSet } = queryProps
        return {
            data: resultSet.chartPivot(),
            seriesNames: resultSet.seriesNames()
        }

    },
    bar: ({ queryProps, isSentiment, clientName }) => {
        const chartType = "bar"
        const { resultSet } = queryProps
        let data = resultSet.chartPivot()
        let seriesNames = resultSet.seriesNames()

        const { measures, dimensions } = resultSet.annotation()

        // check if bar chart is multiseries
        const seriesKey = getMetaKey(dimensions, "series", chartType)
        const valueKey = getMetaKey(measures, "value", chartType)

        if (!seriesKey) {
            // single series
            if (seriesNames?.length > 0) {
                seriesNames[0].title = measures[valueKey]?.shortTitle
                if (!isSentiment) seriesNames[0].color = `${clientName.toUpperCase()}_BAR_CHART`
            }
        } else {
            // multi series
            const seriesIndex = resultSet.query().dimensions.findIndex(d =>
                d == seriesKey
            )
            seriesNames = seriesNames.map(seriesName => {
                const value = seriesName.yValues[seriesIndex]
                const title = `${value[0].toUpperCase()}${value.substr(1)}`
                return {
                    ...seriesName,
                    title: `${value[0].toUpperCase()}${value.substr(1)}`,
                    color: isSentiment ? `${clientName}_${title}`.toUpperCase() :  ``
                }
            })
        }

        return {
            data,
            seriesNames
        }
    },
    pie: ({ queryProps, isSentiment, clientName }) => {
        const { resultSet } = queryProps
        const data = resultSet.chartPivot().map(item => {
            return {
                ...item,
                color: isSentiment ? `${clientName}_${item.category}`.toUpperCase() : ''
            }
        })
        const seriesNames = resultSet.seriesNames()
        return { data, seriesNames }
    },
    table: ({ queryProps }) => {
        const { resultSet, pivotConfig } = queryProps
        const data = resultSet.tablePivot(pivotConfig)
        const columns = resultSet.tableColumns(pivotConfig)

        return {
            data,
            columns
        }
    },
    map: ({ queryProps }) => {
        const chartType = "map"
        const { resultSet } = queryProps
        const { measures, dimensions } = resultSet.annotation()
        const countryKey = getMetaKey(dimensions, "country", chartType)
        const valueKey = getMetaKey(measures, "value", chartType)

        // console.log("map country key:", countryKey)
        // console.log("map value key:", valueKey)


        const data = resultSet.tablePivot().map((item) => {
            return {
                name: item[countryKey],
                value: item[valueKey],
                id: countries.find(c => c.name == item[countryKey])?.code
            }
        }).filter(item => !!item.id)

        // console.log("map data: ", data)

        return { data }
    }

}

const processCubeResults = ({ queryProps, subqueryProps, chartType, isSentiment, clientName }) => {
    return processForChart[chartType]({ queryProps, subqueryProps, isSentiment, clientName })
}

export default processCubeResults